import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { TemplateFieldPersistentData } from '../../shared/template-field-persistent-data.entity';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
    selector: 'edit-template-fields',
    templateUrl: './edit-fields.component.html',
    styleUrls: ['./edit-fields.component.scss']
})
export class EditTemplateFieldsComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { templateId: "string" };
    templateId = "";

    listData: TemplateFieldPersistentData[];
    table: TableData;

    async initParams(): Promise<boolean> {
        this.listData = await this.app.loadDataHandler(async () => RestEndpoint.main().find({templateId: this.templateId}).run("api/tpl/templatefieldpersistentdata").list(TemplateFieldPersistentData), this);

        this.table = new TableData([
            new TableColumn("caption", "Bezeichung"),
            new TableColumn("fieldName", "Feld")
        ], this.listData.map(o => new TableRow("", o, {
            fieldName: o.fieldName,
            caption: o.caption
        })), [new TableSortColumn("caption")]);
        return true;
    }
}
